import Show from '../views/buildings/show'

export default [
    {
        path: '/admin/building/:id',
        name: 'building-show',
        component: Show,
    }
]
